import { getKey, ProviderError } from './shared';
import { t } from '../modules/i18n';

export async function callOpenRouter(model, prompt, signal, opts) {
  const key = getKey("openrouter");
  if (!key) throw new Error(t("err.nokey", { provider: "OpenRouter" }));
  const maxOut = (opts && opts.maxOutTokens) || 8192;
  // OpenRouter accepts Bearer auth + recommends HTTP-Referer + X-Title for ranking/identification
  const r = await fetch("https://openrouter.ai/api/v1/chat/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${key}`,
      "HTTP-Referer": "https://lopettia.ai",
      "X-Title": "Lorenza Compare",
    },
    body: JSON.stringify({
      model,
      messages: [{ role: "user", content: prompt }],
      max_tokens: maxOut,
    }),
    signal,
  });
  if (!r.ok) {
    const err = await r.text();
    throw new ProviderError("OpenRouter", r.status, err);
  }
  const data = await r.json();
  const u = data.usage || {};
  const finishReason = data.choices?.[0]?.finish_reason || "";
  return {
    text: data.choices?.[0]?.message?.content || "",
    inTokens:  u.prompt_tokens     || u.input_tokens  || 0,
    outTokens: u.completion_tokens || u.output_tokens || 0,
    finishReason,
    truncated: finishReason === "length",
  };
}
